import React, { useEffect, useState } from "react";
import { useAuth } from "../../../../hooks";
import { Column } from "@ant-design/plots";
import { convertUnitsFinal } from "../../../../utils/dataAndFormulas/fuelsForms";
import { convertEnergy2 } from "../../../../utils/dataAndFormulas/convertEnergy";
import { kgToTons } from "../../../../utils/dataAndFormulas/GEIForms";
import { useLanguage } from "../../../../contexts/LanguageContext";
import { formatWhole, formatPercentage } from "../../../../utils/numberFormat";
import "./GEISummary.scss";


const FuelsSummary = ({
  filters,
  site,
  valueBaseline,
  fuelsController,
  totales, // ✅ Prop con datos ya calculados desde otro componente
  selectorSlot,
  exportSlot,
}) => {

    const { translations } = useLanguage();
    const t = (key) => translations[key] || key;
  // 🔹 Estado local para guardar los totales anuales procesados
  const [data, setData] = useState({
    total: 0,
    alcance1: 0,
    alcance2: 0,
    alcance3: 0,
  });

  const [results, setResults] = useState({});

  // 🔹 useEffect: se ejecuta cuando cambian filtros o totales
  useEffect(() => {
    const fetchData = async () => {
      try {

        if (totales && Object.keys(totales).length > 0) {
          setResults(totales);


          // console.log(totales[filters.year])
          const alcance1 =     totales[filters.year].scope1 ;

          // 🔹 Suma total de vehículos del año
          const alcance2 = totales[filters.year].scope2;

          // 🔹 Calcula la intensidad: energía total en kWh por vehículo
          const alcance3 = totales[filters.year].scope3;
          //const unidadesBase = cantidad_vehiculos > 0 ? cantidad_vehiculos : 1;

          // 🔹 Actualiza el estado con los resultados del año
          setData({
            total:alcance1+alcance2+alcance3,
            alcance1,
            alcance2,
            alcance3,
          });
        }
      } catch (error) {
        console.error("❌ Error al traer resumen de combustibles:", error);
      }
    };

    fetchData();
  }, [filters, site, valueBaseline, fuelsController, totales]);

  // // 🔹 Porcentaje sobre el total
  const percentAlcance1 =
    data.total > 0
      ? (data.alcance1 / data.total) * 100
      : 0;

        const percentAlcance2 =
    data.total > 0
      ? (data.alcance2 / data.total) * 100
      : 0;

        const percentAlcance3 =
    data.total > 0
      ? (data.alcance3 / data.total) * 100
      : 0;

  // 🔹 Define las tarjetas del resumen (orden y visual)
  const resumenItems = [
    {
      title: t("total_emissions"),
      value: kgToTons(data.total),
      unit: "tCO₂e",
      secondary: "",
      progress: null,
      color: "blue",
      hasProgress: false,
    },
    {
      title: t("scope_1"),
      value: kgToTons(data.alcance1),
      unit: "tCO₂e",
      secondary: formatPercentage(percentAlcance1),
      progress: percentAlcance1,
      color: "green",
      hasProgress: true,
    },
    {
      title: t("scope_2"),
      value: kgToTons(data.alcance2),
      unit: "tCO₂e",
      secondary: formatPercentage(percentAlcance2),
      progress: percentAlcance2,
      color: "green",
      hasProgress: true,
    },
    {
      title: t("scope_3"),
      value: kgToTons(data.alcance3),
      unit: "tCO₂e",
      secondary: formatPercentage(percentAlcance3),
      progress: percentAlcance3,
      color: "green",
      hasProgress: true,
    },
  ];

  // 🔹 Renderiza las tarjetas visuales
  return (
    <div className="resumen-grid">
      {resumenItems.map((item, index) => (
        <div
          key={index}
          className={`resumen-card-col${index === 0 ? " resumen-card-col--first" : ""}`}
        >
          <div className={`resumen-slot-row${index === resumenItems.length - 1 ? " resumen-slot-row--right" : ""}`}>
            {index === 0 && selectorSlot}
            {index === resumenItems.length - 1 && exportSlot}
          </div>
          <div
            className={`resumen-card gei-card ${!item.hasProgress ? "no-progress" : ""}`}
          >
            <div className="card-meta">
              <div className="card-title-row">
                <span className="card-title">{item.title}</span>
              </div>
              <div>
                {item.subtitle && (
                  <span className="card-subtitle">{item.subtitle}</span>
                )}
              </div>
            </div>

            <div className="card-header">
              <span className="card-value">
                {formatWhole(item.value)}
                <span className="card-unit">{item.unit}</span>
              </span>
              {item.secondary && (
                <div className="percentage-text">{item.secondary}</div>
              )}
            </div>

            {item.hasProgress && item.progress !== null && (
              <div className="progress-container">
                <div className="progress-bar">
                  <div
                    className="progress-fill"
                    style={{
                      width: `${Math.round(item.progress || 0)}%`,
                      backgroundColor: item.color || "#648EBC",
                    }}
                  />
                </div>
                {item.legend && (
                  <div className="progress-legend">{item.legend}</div>
                )}
              </div>
            )}

            <div className="empty-space"></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default FuelsSummary;
